import { Row, Select, Spin, Table } from 'antd';
import FileSaver from "file-saver";
import moment from 'moment';
import React, { Component } from 'react';
import TableText from "../../TableText";
import request from '@/method/request';
import _ from 'lodash';
import setCahrt from './compute'
import MonthPicker from '@/template/MonthPicker'
import { calculation } from '@/method';
import MTD from './MTD';
import './index.scss';

const Option = Select.Option;

class index extends Component {
    state = {
        date: moment().subtract(1, 'month').format('YYYY-MM'),
        data: [],
        loading: true,
        loadingSave: false,
        dateData: [],
        print: false,
        dataSelect: []
    }

    componentDidMount() {
        this.getDateData(this.state.date);
        let date = Number(this.state.date || "0");
        let dateData = [];
        let len = date - 2018 + 3;
        for (let i = 0; i < len; i++) {
            dateData.push((2018 + i).toString())
        }
        this.setState({ dateData });
    }

    getDateData = async (date) => {
        const year = moment(date).format('YYYY');
        const month = moment(date).format('M');
        const { data = [] } = await request(`/doobi?year=${year}&month=${month}`);
        data[1].actual = calculation(data[0].actual, data[8].actual);
        data[1].budget = calculation(data[0].budget, data[8].budget);
        setCahrt(data);
        this.setState({ loading: false, data })
    }

    onExpoetExcel = () => {
        this.setState({ print: true, loading: true }, () => {
            const name = `Current Year P&L Analysis (Whole Year Budget) 本年损益分析 （全年预算）${moment(this.state.date).format('YYYY-MM')}`;
            const innerHtml = `
              <caption>${name}</caption>
              ${document.getElementById('table').innerHTML.replace(/<table class="">/g, '<table border="1">')}
            `;

            var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
            var blob = new Blob([html], { type: "application/vnd.ms-excel" });
            FileSaver.saveAs(blob, `${name}.xls`);
            this.setState({ print: false, loading: false });
        });
    }

    render() {
        const { date, data, loading } = this.state;
        const percentData = [1, 2];
        let columns = [{
            title: "P&L Index 损益指数",
            dataIndex: 'name',
            key: 'name',
            render: (text, r, index) => {
                const props = {
                    text, index, type: 'text', name: "name"
                };
                return <TableText data={props} />
            }
        }, {
            title: "Actual 实际",
            width: 150,
            dataIndex: 'actual',
            key: 'actual',
            render: (text, r, index) => {
                const props = {
                    text, index, type: percentData.includes(index) ? 'percent' : 'number', name: "actual"
                };
                return <TableText data={props} />
            }
        }, {
            title: "Budget 预算",
            width: 150,
            dataIndex: 'budget',
            key: 'budget',
            render: (text, r, index) => {
                const props = {
                    text, index, type: percentData.includes(index) ? 'percent' : 'number', name: "budget"
                };
                return <TableText data={props} />
            }
        }];
        return (
            <div>
                <MTD></MTD>
                <Spin spinning={loading} >

                    <div className="table table2_1 doobi">
                        <Row className="title" id="table2_2" >
                            <Row>BI Structure YTD - DOO 总部数据平台 YTD - DOO</Row>
                            <Row className="table-month">
                                <MonthPicker date={date}
                                    onChange={(date, str) => {
                                        this.setState({
                                            date: str,
                                            data: [],
                                            loading: true
                                        });
                                        this.getDateData(str)
                                    }} />
                            </Row>
                            <div className="content">
                                <Table
                                    columns={columns}
                                    dataSource={data}
                                    size="middle"
                                    id="table"
                                    bordered
                                    style={{ width: 600 }}
                                    pagination={false}
                                    rowKey={(record, index) => {
                                        return index
                                    }}
                                />
                                <div className="chart">
                                    <div id="chart1"></div>
                                    <div id="chart2"></div>
                                </div>
                            </div>

                        </Row>
                    </div>
                </Spin>
            </div>

        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/other/DooBi/index.js